// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".weblink-table-display__weblink-icon[data-v-46d71b0c]{height:26px;width:22px}@media only screen and (max-width:959px){.weblink-table-display__divider[data-v-46d71b0c]{border-bottom:2px solid var(--v-softened-base)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
